import React, { useState } from 'react';
import { Icon } from '@iconify/react';

const NavToggle = () => {
  const [menuFlip, setMenuFlip] = useState(false);
  const minifySidebar = e => {
    e.preventDefault();
    if (document.body.classList.contains('nav-function-minify')) {
      document.body.classList.remove('nav-function-minify');
      document.body.classList.remove('mod-hide-info-card');
      setMenuFlip(false);
    } else {
      document.body.classList.add('nav-function-minify');
      document.body.classList.add('mod-hide-info-card');
      setMenuFlip(true);
    }
  };
  const mobileNavOn = e => {
    e.preventDefault();
    if (document.body.classList.contains('mobile-nav-on')) {
      document.body.classList.remove('mobile-nav-on');
    } else {
      document.body.classList.add('mobile-nav-on');
    }
  };
  return (
    <>
      <div className="hidden-md-down dropdown-icon-menu position-relative">
        <a
          href=""
          className="header-btn btn js-waves-off"
          title="Hide Navigation"
          onClick={minifySidebar}
        >
          { menuFlip ? <Icon icon="mdi:menu-open" flip="horizontal" /> : <Icon icon="mdi:menu-open" /> }
        </a>
      </div>
      <div className="hidden-lg-up">
        <a
          href=""
          className="header-btn btn press-scale-down waves-effect waves-themed"
          title="Open Navigation"
          onClick={mobileNavOn}
        >
          <Icon icon="mdi:menu" />
        </a>
      </div>
    </>
  );
};

export default NavToggle;
